/** Class on <html> that switches PrimeNG to its dark palette. */
export const PRIMENG_DARK_MODE_CLASS = 'app-dark';
